"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgLightbulbSlash = function SvgLightbulbSlash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M10 15a1 1 0 01-1 1H7a1 1 0 01-1-1 1 1 0 010-2h4a1 1 0 010 2zm1.963-9.549l-6.24 6.24a.992.992 0 01-.032.032l-3.984 3.984a1 1 0 11-1.414-1.414l3.464-3.465c-.061-.1-.126-.201-.196-.306-.081-.123-.455-.669-.555-.822C2.296 8.61 2 7.64 2 6A6 6 0 019.225.125a1 1 0 01-.406 1.959A4 4 0 004 6c0 1.247.18 1.84.681 2.608.078.119.4.59.524.773L14.293.293a1 1 0 011.414 1.414l-2.115 2.115C13.86 4.51 14 5.246 14 6c0 1.208-.26 2.132-.815 3.172-.171.32-.866 1.486-1.019 1.763a1 1 0 11-1.75-.969c.177-.32.861-1.467 1.004-1.735C11.83 7.465 12 6.857 12 6c0-.185-.013-.368-.037-.549z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

SvgLightbulbSlash.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgLightbulbSlash;
exports.default = _default;